import { render, staticRenderFns } from "./mailmag.vue?vue&type=template&id=c0e08532&scoped=true&"
import script from "./mailmag.vue?vue&type=script&lang=js&"
export * from "./mailmag.vue?vue&type=script&lang=js&"
import style0 from "./mailmag.vue?vue&type=style&index=0&id=c0e08532&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e08532",
  null
  
)

export default component.exports